import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { format, parseISO } from 'date-fns';
import { SalesOfficeService } from '../sales-office.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { LOCALIZED_PROPERTIES, SALES_OFFICE_EXPORT_ID, SALES_OFFICE_TITLE } from './sales-office.constants';
import { salesOfficeType } from './sales-office-type';
import ShortDivisionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division-short/division.short.entity';
import { ShortWarehouseAttributes } from '@albatrosdeveloper/ave-models-package';

@Injectable()
export class SalesOfficeExport {
  constructor(
    private exportService: ExportService,
    private salesOfficeService: SalesOfficeService,
  ) {}

  private transformItem(item: SalesOfficeAttributes) {
    return {
      externalKeys: get(item, 'externalKeys.code', ''),
      name: get(item, 'name', ''),
      officeGroup: get(item, 'officeGroup.name', ''),
      company: get(item, 'company.name', ''),
      type: salesOfficeType(get(item, 'type', '')),
      divisions: this.getList<ShortDivisionAttributes>(get(item, 'divisions', [])),
      channel: get(item, 'distributionchain.channel.name', ''),
      distributionchain: get(item, 'distributionchain.name', ''),
      warehouses: this.getList<ShortWarehouseAttributes>(get(item, 'warehouses', [])),
      //distributionchaininherit
      status: ExportTaskProcessor.types.ave.status(get(item, 'statusId', '-')),
    };
  }

  private getList<T extends { name: string }>(items: T[]): string {
    if (!Array.isArray(items) || items.length === 0) return '-';
    return items.map((division) => division.name).join(', ');
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: SALES_OFFICE_EXPORT_ID,
      title: SALES_OFFICE_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(SALES_OFFICE_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.salesOfficeService.findByFilter(buildQuery(
          seed(this.salesOfficeService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(SALES_OFFICE_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(SALES_OFFICE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
